import { createContext, useContext, useMemo, useState } from 'react'
import NeuvoteLogo from '@nv/images/logos/neuvote/neuvote-logo'
import NeuvoteLogoCollapsed from '@nv/images/logos/neuvote/neuvote-logo-collapsed'

export const ThemeContext = createContext()

const defaultTheme = {
  bgColor: 'var(--color-white)',
  textColor: 'var(--color-black)',
  Logo: NeuvoteLogo,
  MobileLogo: NeuvoteLogoCollapsed,
}

export const ThemeProvider = ({ children, initialTheme = defaultTheme }) => {
  const [theme, setTheme] = useState(initialTheme ?? defaultTheme)

  const value = useMemo(() => ({ theme, setTheme }), [theme])

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
}

export const useThemeContext = () => useContext(ThemeContext)
